import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { PaymentMethods as RedesignPaymentMethods } from '../../../pages';
import * as Api from '../../Api';
import * as Data from '../../Data';
import { basketSelectors, paymentActions, paymentSelectors } from '../../redux';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyPayment } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignPaymentMethods,
  LegacyPayment,
);

export type StateProps = {
  AppConfig: Data.Async<Api.AppConfig>;
  Customer: Data.Async<Api.Customer>;
  payments: WebOrder.State.Payment[];
  translate: any;
};
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State) => {
  let payments = paymentSelectors.getRemovablePayments(state);
  const restaurant = basketSelectors.getRestaurantDetails(state);

  // WHY THIS, WHY???
  if (restaurant && restaurant.AcceptCardOrders === false) {
    payments = payments.filter(
      (p) => p.PaymentAccountType !== 'CardPaymentAccount',
    );
  }

  return {
    AppConfig: state.flipdish.AppConfig,
    Customer: state.flipdish.Customer,
    payments,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    paymentRemoved: (payload: { paymentId: string }) => {
      dispatch(paymentActions.paymentRemoved(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
